import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../shared/loader'
import CryptoJS from 'crypto-js'
import Pagination from './../shared/pagination'

import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
export default {
	name: 'pickertransfer',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		Loader,
		BasicSelect
	},
	data() {
		return {
			totalRows: 0,
			currentPage: 1,

			// getNewWarehouseData:'',
			listOrdersData: [],
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			orderid: "",
			fromDateFlt: "",
			toDateFlt: "",
			newActionMsg: "",
			modelMessage: "",
			// totalPage: 0,
			totalPage: 0,
			activeClass: 'btn-success',
			warningClass: 'btn-warning',
			clientdata: [],
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			listMerchantData: [],
			clientid: '',
			client: '',
			merchant: '',
			warehouseid: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			SelectPickerErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			pickerTransferShow: false,
			cancelOrderId: [],
			loginuserid: '',
			searchchannel: '',
			channellist: [],
			pickerid: '',
			isLoading: false,
			pickerListData: '',
			pageLimit: 10,

			selectAll: false,
			orderids: [],
			orderclass: '',
			searchpickerid: '',
			onlyorderid: [],
			orderidsarr: [],
			item: {
				value: '',
				text: ''
			},
			listMerchantData1: [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }],
		}
	},
	// filters: {
	// 	moment: function (date) {
	// 		return moment(date).format('DD-MM-YYYY HH:mm:ss');
	// 	},
	// 	moment1: function (date) {
	// 		return moment(date).format('DD-MM-YYYY');
	// 	}
	// },
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		this.loginuserid = userdetail.userid;
		this.pageNo = 0;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantList();
		this.getSalesChannels();
		this.getPickersList();
		}
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getPickersList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error( this.$t('common.unauthorisedError'));
				break
		}
	}, // End computed
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {
			// select option from parent component
			this.item = item
			this.merchant = item.value;

		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		// dateFormatFRT(date) {
		// 	if (!date) return '';
		// 	return moment(date).format('DD-MM-YY HH:mm:ss');
		// },
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		selectAllCheckbox: function () {
			//this.rackIds = [];
			if (this.selectAll) {
				for (let order in this.listOrdersData) {
					if (this.orderids.indexOf(this.listOrdersData[order].orderid) == -1) {
						this.orderids.push(this.listOrdersData[order].orderid);
					}
					this.orderidsarr.push(this.listOrdersData[order].idforb2b);
				}
				console.log(this.orderidsarr, "orderidsarr");
			} else {
				this.orderidsarr = []
				for (let order in this.listOrdersData) {
					if (this.orderids.indexOf(this.listOrdersData[order].orderid) >= 0)
						this.orderids.splice(this.orderids.indexOf(this.listOrdersData[order].orderid), 1);
				}
			}
		},
		resetAll: function (myAction) {
			if (myAction == 1) {
				this.orderids = [];
				this.selectAll = false;
			} else if (this.orderidsarr.length < 10)
				this.selectAll = false;
			else if (this.orderidsarr.length == 10)
				this.selectAll = true;

		},

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: window.localStorage.getItem("selectedClient"),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.item = {
							value: '',
							text: ''
						},
							this.listMerchantData1 = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }]
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname

							})
						})

					}
				}, error => {
					//	console.error(error);
				})
		},

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		getPickersList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehousePickerList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.pickerListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.getMerchantList();
		// 		this.merchant = '';
		// 		this.clientid = this.client;
		// 		if (this.clientid)
		// 			this.getSalesChannels();
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.getPickersList();
		// 				this.getMerchantList();
		// 				//this.getOrderList();
		// 			}
		// 		}
		// 	}
		// 	this.totalRows = 0;
		// 	this.listOrdersData = [];
		// 	this.pageNo = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.totalRows = 0;
		// 	this.warehouseid = this.warehouse;
		// 	this.pageNo = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getPickersList();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.clientid == '') {
				this.WarehouseErr = "Client is required";
				return false;
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderSalesChannelList',
				'data': {
					clientid: window.localStorage.getItem("selectedClient")
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		getOrderList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.fromdate != "") {
				this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
			}
			if (this.todate != "") {
				this.todate = this.dateFormat(this.todate) + " 23:59:59";
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			// this.ClientErr = '';

			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: window.localStorage.getItem("selectedClient"),
				orderid: this.orderid.trim(),
				fromddate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				saleschannel: this.searchchannel,
				orderclass: this.orderclass,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				pickerid: this.searchpickerid,
				merchantid: this.merchant,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'pickerAllocatedOrderList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listOrdersData = result.data.data.data.data;

					if (result.data.data.ErrorCode == 1) {
						this.resultCount = 0;
					} else {
						this.totalRows = result.data.data.data.count;
						this.resultCount = result.data.data.data.count;

						if (this.totalRows > 0) {
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit)
							}
						}
					}
					this.isLoading = false;
					this.selectAll = false;
					this.orderidsarr = [];
					this.listOrdersData.forEach(e => {
						this.onlyorderid.push(e.orderid)
					})

				}, error => {
					console.error(error)
				})
		},
		transferOrderToPicker() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.orderids = this.orderidsarr
			this.pickerTransferShow = false;
			if (window.localStorage.getItem("selectedClient") == '') {
				this.$alertify.error(this.$t('common.clientMsg'));
				return false;
			}
			if (this.orderids == 0) {
				this.$alertify.error(this.$t('common.orderMsg'));
				return false;
			}
			if (this.pickerid == 0) {
				this.$alertify.error(this.$t('common.selectPickerErr'));
				return false;
			}


			this.isLoading = true;
			let orderidsnew = [], oir_ids = [], rack_ids = []
			this.orderids.forEach(e => {
				if (this.onlyorderid.includes(e)) {
					orderidsnew.push(e)

				}
				else {
					oir_ids.push(e)
				}
			})
			this.listOrdersData.forEach(e => {
				if (oir_ids.includes(e.idforb2b))
					rack_ids.push({ "rackid": e.rackforb2b, "orderid": e.orderid })
			})




			this.input = {
				clientid: window.localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				selectedorder: orderidsnew,
				userid: this.loginuserid,
				pickerid: this.pickerid,
				oir_ids: rack_ids,
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'transferOrderToPicker',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.$alertify.success(result.data.data.msg);
						this.getOrderSerach()
					} else {
						this.$alertify.error(result.data.data.msg);
					}
					this.isLoading = false;
					this.selectAll = false;
					this.pickerid = '';
					this.orderids = [];
					this.orderidsarr = [];

				}, error => {
					console.error(error);
				});
		},

		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit
		// 	this.getOrderList()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.selectAll = false;
			this.getOrderList()
		},
		getOrderSerach() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = true;
			this.getOrderList();
		},
		resetOrderSerach() {
			this.item = {
				value: '',
				text: ''
			};
			// this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
			this.totalRows = 0;
			this.orderid = '';
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.listOrdersData = [];
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = false;
			this.searchchannel = '';
			this.pickerid = '';
			this.orderids = [];
			this.searchpickerid = '';
			this.orderclass = '';
			// if (this.user_type == 'warehouse_user')
			// 	// this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},

		onSubmit: function () {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	} // end methods
};



// WEBPACK FOOTER //
// ./src/views/components/pickerTransfer/pickerTransfer.component.js